module.exports = __webpack_public_path__ + "img/whtop_bg.58f48109.jpg";